<template>
    <el-select v-if="componentShow" ref="zmLocalSel" :clearable="clearable" filterable v-model="newValue" :tabindex="tabindex" :name="name"
               style="width: 100%"  :multiple="multiple" :disabled="disabled" placeholder="" :allow-create="allowCreate"
               :default-first-option="defaultFirstOption"
               :collapse-tags="collapseTags" @change="selectChange">
        <el-option v-for="item in datas" :key="item[optionKey]" :label="item[selLabel]" :value="item[selVal]"></el-option>
    </el-select>
</template>

<script>
    export default {
        name: "ZmLocalSelect",
        props: {
            value:{
                type:[String,Array]
            },
            clearable:{
                type:Boolean,
                default:true
            },
            multiple:{
                type:Boolean,
                default:false
            },
            allowCreate:{
                type:Boolean,
                default:false
            },
            defaultFirstOption:{
                type:Boolean,
                default:true
            },
            disabled:{
                type:Boolean,
                default:false
            },
            collapseTags:{
                type:Boolean,
                default:false
            },
            tabindex:{
                type:String
            },
            filterData:{
                type:Function
            },
            datas:{
                type:Array,
                required:true
            },
            name:{
                type:String
            },
            selVal:{
                type:String,
                default:'value'
            },
            selLabel:{
                type:String,
                default:'label'
            },
            selKey:{
                type:String
            }
        },
        data(){
            return {
                componentShow:true,
                optionKey:''
            }
        },
        created(){
            if(this.selKey){
                this.optionKey = this.selKey;
            }else{
                this.optionKey = this.selVal;
            }
        },
        computed:{
            newValue: {
                get:function() {
                    return this.value;
                },
                set:function(value) {
                    this.$emit('input', value);
                }
            }
        },
        methods: {
            setValue(val){
                if(val && this.datas && this.datas.length > 0){
                    let valObj = this.datas.find((item)=>{
                        return item.value === val;
                    });
                    if(valObj){
                        this.newValue = val;
                    }
                }
            },
            selectChange(val){
                //多选返回选择数据数组  单选返回选择对象
                if(this.multiple){
                    if(val && val.length > 0){
                        var returnArr = [];
                        this.datas.forEach((item, index) => {
                            if(val.indexOf(item.value) > -1){
                                returnArr.push(item);
                            }
                        });
                        this.$emit('change',returnArr);
                    }else{
                        this.$emit('change',[]);
                    }
                }else{
                    let obj = {};
                    obj = this.datas.find((item)=>{
                        return item.value === val;
                    });
                    this.$emit('change',obj);
                }
            },
            focus(){
                this.$refs['zmLocalSel'].focus();
            }

        },
        beforeDestroy(){
            this.componentShow = false;
        }
    };
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/zmLocalSelect/index.vue